import * as R from "ramda";
import React, {Component} from "react";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleTextArea from "../../../../../modules/simpleTextArea";
import {mapToObjectDDL} from "../../../../common/mapper";
import {ACTIVITY_TYPE} from "../../../../common/Constants";
import {getSupplierExpOptions} from "../util";
import M from "moment/moment";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import FlexView from "react-flexview";
import InventorySearchDataSPBM from "./inventorySearchDataSPBM";

class ReceivingInputs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            spbmModalVisible: false,
        }
    }

    handleSelecSpbmModalVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            spbmModalVisible: !prevState.spbmModalVisible
        }))
    }

    handleSubmitSelectSPBM = (data) => {
        if (!R.isNil(data)) {
            this.props.setValue("spbmNo", data.spbmNo)
            this.props.setValue("spbmDate", data.spbmDate)
            this.props.setValue("slNo", data.slNo)
            this.props.setValue("slDate", data.slDate)
        }

        this.handleSelecSpbmModalVisibility();
    }

    render() {
        return (
            <>
                <div className="grid grid-3x grid-mobile-none gap-15px">
                    <div id="grid-1">
                        <SimpleInput
                            id={`input_text_${this.props.inputConfig.noName}`}
                            name={"spblNo"}
                            readOnly
                            label={this.props.inputConfig.noLabel}
                            value={this.props.controls.spblNo.value}
                            onChange={({target}) =>
                                this.props.setValue(target.name, target.value)
                            }
                        />
                        <FlexView vAlignContent={"center"}>
                            <SimpleInput
                                id="input_text_nospbm"
                                name="spbmNo"
                                label="No. SPBM"
                                readOnly
                                containerclassname="width width-full"
                                value={this.props.controls?.spbmNo?.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            {(R.equals(this.props.activityType, ACTIVITY_TYPE.CREATE) || !this.props.activityRead) && (
                                <SimpleButton
                                    secondary
                                    text={"..."}
                                    className="margin-top-5px"
                                    styles={{
                                        width: "unset",
                                        marginLeft: "2px",
                                        border: "1px solid #ccc",
                                        backgroundColor: (R.equals(this.props.activityType, ACTIVITY_TYPE.CREATE) || !this.props.activityRead) ? "#fff" : "#E6E6E6"
                                    }}
                                    onClick={this.handleSelecSpbmModalVisibility}
                                />
                            )}
                        </FlexView>
                        <SimpleInput
                            id="input_text_nosl"
                            name="slNo"
                            label="No. SL"
                            readOnly
                            value={this.props.controls?.slNo?.value}
                            onChange={({target}) =>
                                this.props.setValue(target.name, target.value)
                            }
                        />
                    </div>
                    <div id="grid-2">
                        <SimpleDate
                            id={`select_date_${this.props.inputConfig.dateName}`}
                            name="spblDate"
                            label={this.props.inputConfig?.dateLabel}
                            date={this.props.controls?.spblDate?.value}
                            disabled={this.props.activityRead || R.equals(this.props.activityType, ACTIVITY_TYPE.CREATE)}
                            onChange={(value) =>
                                this.props.setValue("spblDate", M(value).format("DD-MM-YYYY"))
                            }
                        />
                        <SimpleDate
                            id="select_date_tglspbm"
                            name="spbmDate"
                            label="Tgl. SPBM"
                            disabled
                            date={this.props.controls?.spbmDate?.value}
                            onChange={(value) =>
                                this.props.setValue("spbmDate", M(value).format("DD-MM-YYYY"))
                            }
                        />
                        <SimpleDate
                            id="select_date_tglsl"
                            name="slDate"
                            label="Tgl. SL"
                            disabled
                            date={this.props.controls?.slDate?.value}
                            onChange={({target}) =>
                                this.props.setValue(target.name, target.value)
                            }
                        />
                    </div>
                    <div id="grid-3">
                        <SimpleDDL
                            id="select_options_nama_supp"
                            name="idSupplier"
                            mandatory
                            label="Nama Supp."
                            box={"search"}
                            isClearable={true}
                            errorMessage={this.props.errors.idSupplier}
                            readOnly={R.equals(this.props.activityType, ACTIVITY_TYPE.UPDATE)}
                            options={this.props.dataSupplier?.length > 0
                                ? this.props.dataSupplier.map(
                                    item => mapToObjectDDL(
                                        item.supplierName,
                                        item.supplierCode
                                    )
                                )
                                : []
                            }
                            value={this.props.controls.idSupplier?.value}
                            onChange={(value, {name}) =>
                                this.props.setValue(name, value)
                            }
                        />
                        <SimpleInput
                            id="input_text_no_pol_truk"
                            name="noPolKendaraan"
                            label="No. Pol Truk"
                            value={this.props.controls.noPolKendaraan?.value}
                            readOnly={R.equals(this.props.activityType, ACTIVITY_TYPE.UPDATE) && this.props.activityRead}
                            onChange={({target}) =>
                                this.props.setValue(target.name, target.value)
                            }
                        />
                        <SimpleDDL
                            id="select_options_ekpedisi"
                            name="idSupplierExpedisi"
                            box={"search"}
                            label="Ekspedisi"
                            isClearable={true}
                            readOnly={R.equals(this.props.activityType, ACTIVITY_TYPE.UPDATE) && this.props.activityRead}
                            options={this.props.dataSupplierExpedition?.length > 0
                                ? getSupplierExpOptions(this.props.dataSupplierExpedition)
                                : []
                            }
                            value={this.props.controls.idSupplierExpedisi.value}
                            onChange={(value, {name}) =>
                                this.props.setValue(name, value)
                            }
                        />
                    </div>
                </div>
                <div
                    style={{
                        display: "grid",
                        gap: "15px",
                        gridTemplateColumns: "1fr 1fr",
                    }}
                >
                    <SimpleTextArea
                        typeInputCase="normal"
                        name="note"
                        label="Catatan"
                        readOnly={R.equals(this.props.activityType, ACTIVITY_TYPE.UPDATE) && this.props.activityRead}
                        value={this.props.controls.note.value}
                        onChange={({target}) =>
                            this.props.setValue(target.name, target.value)
                        }
                    />
                    <p style={{justifySelf: "end"}}>{this.props.controls.idSupplierExpedisi?.value?.name}</p>
                </div>

                {this.state.spbmModalVisible && (
                    <InventorySearchDataSPBM
                        {...this.props}
                        onSubmit={this.handleSubmitSelectSPBM}
                        visible={this.state.spbmModalVisible}
                        onClickClose={this.handleSelecSpbmModalVisibility}
                    />
                )}
            </>
        );
    }
}

export default ReceivingInputs;
